export default __webpack_public_path__ + "static/media/BattleChallengeLogo.d003abb1.png";